module.exports = __webpack_public_path__ + "img/image_6.b3a7a891.jpg";